import styled from '@emotion/styled'

export const L1NotificationDot = styled.div(({theme}) => ({
	width: '10px',
	height: '10px',
	borderRadius: '50%',
	background: theme.colors.stopRed,
	border: `1px solid ${theme.colors.white}`
}))

export const L1NotificationDotPositioner = styled.div(({theme}) => ({
	position: 'absolute',
	top: 0,
	right: 0,
	margin: theme.spacing(-0.5, -0.5, 0, 0),
}))

export default L1NotificationDot
